import PropTypes from "prop-types";
import React, { Component } from "react";
import autobind from "autobind-decorator";
import Editor from "./TextEditor/";
import { equals, pathOr } from "ramda";

export default class TextEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
  }

  componentDidUpdate(prevProps) {
    if (!equals(prevProps.value, this.props.value)) {
      this.setState({
        value: this.props.value
      });
    }
  }

  @autobind
  onBlur() {
    this.props.onChange(this.state.value);
  }

  @autobind
  onChange(value) {
    this.setState({
      value
    });
  }

  render() {
    return (
      <Editor
        maxLength={this.props.maxLength}
        disabled={this.props.disabled}
        autocomplete={this.props.autocomplete}
        onBlur={this.onBlur}
        onChange={this.onChange}
        value={this.state.value}
        placeholder={pathOr(
          "",
          ["column", "settings", "placeholder"],
          this.props
        )}
      />
    );
  }
}

TextEditor.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.object
};
